module.exports = __webpack_public_path__ + "r-v3/img/ico_white_noise.64e1caff.svg";